import React from 'react';
import { useAppContext } from '../contexts/AppContext';
import dingSound from '../images/ding.mp3';

const ding = new Audio(dingSound);

const Link = ({ to, children, className = '', onClick, ...props }) => {
  const { navigate } = useAppContext();

  const handleClick = (event) => {
    ding.currentTime = 0;
    ding.play().catch(() => {});

    // Call the navigate function with the 'to' prop
    navigate(to);

    // Call any additional onClick handler if provided
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={className}
      {...props}
    >
      {children}
    </button>
  );
};

export default Link;